// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/lib/supabase";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import AdminDashboardLayout from "@/layouts/AdminDashboardLayout";
import OrgAdminDashboardLayout from "@/layouts/OrgAdminDashboardLayout";

const PLATFORM_ROLES = ["admin", "rlevents_super_admin", "super_admin"];
const ORG_ROLES = ["org_admin", "rlevents_tenant_admin"];

/**
 * Routes users hitting the admin area to the correct shell:
 *  - Platform admins (admin / super admin)  -> full AdminDashboardLayout
 *  - Org admins (org_admin / tenant admin)  -> reduced OrgAdminDashboardLayout
 * Both layouts mount the SAME nested admin-dashboard routes.
 */
const AdminAreaLayout: React.FC = () => {
  const { user, profile, isLoading } = useAuth();
  const navigate = useNavigate();
  const [resolved, setResolved] = useState(false);
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(false);
  const [isOrgAdmin, setIsOrgAdmin] = useState(false);

  useEffect(() => {
    if (isLoading) return;
    if (!user) {
      navigate("/auth/login", { state: { from: "/admin-dashboard" } });
      return;
    }

    (async () => {
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id);
      const roles = (data || []).map((r) => r.role);

      // Authorization comes from user_roles only — profiles.role is display data.
      const platform = roles.some((r) => PLATFORM_ROLES.includes(r));
      const org = roles.some((r) => ORG_ROLES.includes(r));

      if (platform) {
        setIsPlatformAdmin(true);
      } else if (org) {
        setIsOrgAdmin(true);
      } else {
        toast.error("You don't have admin privileges to access this area");
        navigate("/dashboard");
        return;
      }
      setResolved(true);
    })();
  }, [user, profile, isLoading, navigate]);

  if (isLoading || !resolved) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="ml-2 text-lg font-medium">Loading...</span>
      </div>
    );
  }

  if (isOrgAdmin && !isPlatformAdmin) {
    return <OrgAdminDashboardLayout />;
  }
  return <AdminDashboardLayout />;
};

export default AdminAreaLayout;
